import createIcon from '../../createIcon';

/**
 * @component @name WorkHistory
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTcuNSAxMC41QzE4Ljk5IDEwLjUgMjAuMzcgMTAuOTcgMjEuNSAxMS43NlY3LjVDMjEuNSA2LjM5IDIwLjYxIDUuNSAxOS41IDUuNUgxNS41VjMuNUMxNS41IDIuMzkgMTQuNjEgMS41IDEzLjUgMS41SDkuNUM4LjM5IDEuNSA3LjUgMi4zOSA3LjUgMy41VjUuNUgzLjVDMi4zOSA1LjUgMS41MSA2LjM5IDEuNTEgNy41TDEuNSAxOC41QzEuNSAxOS42MSAyLjM5IDIwLjUgMy41IDIwLjVIMTEuMThDMTAuNzUgMTkuNTkgMTAuNSAxOC41OCAxMC41IDE3LjVDMTAuNSAxMy42MyAxMy42MyAxMC41IDE3LjUgMTAuNVpNOS41IDMuNUgxMy41VjUuNUg5LjVWMy41WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTE3LjUgMTIuNUMxNC43NCAxMi41IDEyLjUgMTQuNzQgMTIuNSAxNy41QzEyLjUgMjAuMjYgMTQuNzQgMjIuNSAxNy41IDIyLjVDMjAuMjYgMjIuNSAyMi41IDIwLjI2IDIyLjUgMTcuNUMyMi41IDE0Ljc0IDIwLjI2IDEyLjUgMTcuNSAxMi41Wk0xOS4xNSAxOS44NUwxNyAxNy43VjE0LjVIMThWMTcuMjlMMTkuODUgMTkuMTRMMTkuMTUgMTkuODVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const WorkHistory = createIcon('WorkHistory', [
  [
    'path',
    {
      d: 'M17.5 10.5C18.99 10.5 20.37 10.97 21.5 11.76V7.5C21.5 6.39 20.61 5.5 19.5 5.5H15.5V3.5C15.5 2.39 14.61 1.5 13.5 1.5H9.5C8.39 1.5 7.5 2.39 7.5 3.5V5.5H3.5C2.39 5.5 1.51 6.39 1.51 7.5L1.5 18.5C1.5 19.61 2.39 20.5 3.5 20.5H11.18C10.75 19.59 10.5 18.58 10.5 17.5C10.5 13.63 13.63 10.5 17.5 10.5ZM9.5 3.5H13.5V5.5H9.5V3.5Z',
      key: '1xa0r7',
    },
  ],
  [
    'path',
    {
      d: 'M17.5 12.5C14.74 12.5 12.5 14.74 12.5 17.5C12.5 20.26 14.74 22.5 17.5 22.5C20.26 22.5 22.5 20.26 22.5 17.5C22.5 14.74 20.26 12.5 17.5 12.5ZM19.15 19.85L17 17.7V14.5H18V17.29L19.85 19.14L19.15 19.85Z',
      key: '1kiest',
    },
  ],
]);

export default WorkHistory;
